import { Body, Vec2 } from '../types.js';

export function computeAccelerations(
  bodies: Body[],
  G: number,
  softening: number = 5
): { ax: number; ay: number }[] {
  const accels: { ax: number; ay: number }[] = bodies.map(() => ({ ax: 0, ay: 0 }));

  for (let i = 0; i < bodies.length; i++) {
    for (let j = i + 1; j < bodies.length; j++) {
      const dx = bodies[j].x - bodies[i].x;
      const dy = bodies[j].y - bodies[i].y;
      const distSq = dx * dx + dy * dy + softening * softening;
      const dist = Math.sqrt(distSq);
      const forceMag = G * bodies[i].mass * bodies[j].mass / distSq;

      const fx = forceMag * dx / dist;
      const fy = forceMag * dy / dist;

      accels[i].ax += fx / bodies[i].mass;
      accels[i].ay += fy / bodies[i].mass;
      accels[j].ax -= fx / bodies[j].mass;
      accels[j].ay -= fy / bodies[j].mass;
    }
  }

  return accels;
}
